<template>
  <div class="login-page page-padding-top">
    <div class="login-top flex-center-between" v-if="!hideTopBar">
      <div class="back">
        <Icon name="arrow-left" @click="back" size="20" color="#353945"></Icon>
      </div>
      <span class="page-title">{{step == 2 ? $t('login.title4') : ''}}</span>
      <div class="lang-switch" @click="toLangPage">
        <Icon name="wap-nav" size="20" color="#353945"></Icon>
        <span class="lang-text">{{currentLangName}}</span>
      </div>
    </div>

    <div class="logo" v-show="step == 1">
      <img :src="logoUrl" alt="" style="width: 4rem;">
    </div>
<!--    <div class="sub-title" v-show="step == 1">{{i18n.t('login.title2')}}</div>-->
    <div class="modal-title" v-show="step == 1">{{i18n.t('login.title3')}}</div>

    <div class="tabs" v-show="step == 1">
      <div class="tab" :class="tabIndex == 1 ? 'active' : ''" @click="changeTab(1)">{{i18n.t('login.tab')}}</div>
      <div class="tab" :class="tabIndex == 2 ? 'active' : ''" @click="changeTab(2)">{{i18n.t('login.tab2')}}</div>
    </div>

    <div class="page-desc" v-show="step == 2">{{$t('register.label4')}} {{tabIndex == 1 ? form.username : form.phone}} {{$t('register.label5')}}</div>

    <div class="login-form">
      <div class="form-label" v-if="tabIndex == 1 && step == 1">{{$t('login.label1')}}</div>
      <div class="form-item  flex-center" v-if="tabIndex == 1 && step == 1">
        <div class="input">
          <input type="text" v-model="form.username" :placeholder="i18n.t('login.labelPlaceholder1')">
        </div>
      </div>

      <div class="form-label" v-if="tabIndex == 2 && step == 1">{{$t('login.label2')}}</div>
      <div class="form-item  flex-center " :class="inputActive ? 'active' : ''" v-if="tabIndex == 2 && step == 1">
        <div class="pre flex-center-start" @click="changePre">
          {{phonePre}}
          &nbsp;&nbsp;
          <icon name="arrow-down" size="14" color="#353945"></icon>
        </div>
        <div class="flex-1">
          <div class="input clear">
            <input type="tel" v-model="form.phone" @focus="inputActive = true" @blur="inputActive = false" :placeholder="i18n.t('login.labelPlaceholder5')">
          </div>
        </div>
      </div>

      <div class="form-label" v-show="step == 1">{{$t('login.label3')}}</div>
      <div class="form-item flex-center" v-show="step == 1">
        <div class="input">
          <input :type="showPassword ? 'text' : 'password'" v-model="form.password" :placeholder="i18n.t('login.labelPlaceholder2')">
        </div>
        <div class="adot" @click="changePassword">
          <img :src="eyeUrl" alt="" v-show="!showPassword">
          <img :src="eyeUrl2" alt="" v-show="showPassword">
        </div>
      </div>

      <div class="form-label" v-show="step == 2 ">
        {{$t(`register.label6_${tabIndex}`)}}
      </div>

      <div class="form-item clear flex-center" v-show="step == 2" >
        <div class="input long">
          <input type="tel"  v-model="form.code"  :placeholder="i18n.t('register.labelPlaceholder2')">
        </div>
        <div class="adot long">
          <span class="gray" v-if="isDisabled">{{$t('register.send')}}({{timeCount}})</span>
          <span v-else @click="resend">{{$t('register.btn1')}}</span>
        </div>
      </div>
    </div>


    <Button class="login-btn" :class="btnShow ? '' : 'disabled'" @click="submit">{{i18n.t(`login.btn${step}`)}}</Button>

    <div class="flex-center-between bottom-line" v-show="step == 1">
      <div class="text" @click="toRegister">{{i18n.t('login.register')}}</div>
      <div class="forget " @click="toPath('resetPassword')"> {{i18n.t('login.forget')}}</div>
    </div>

    <Popup v-model:show="showPopup" position="bottom">
			<div class="country-list" >
				<div class="title flex-center-between">
          <icon name="arrow-left" size="20" color="#000" @click="cancel"></icon>
          <span>{{i18n.t('login.labelPlaceholder3')}}</span>
          <span></span>
        </div>
        <div class="search-list flex-center-between">
          <div class="flex-center">
            <img :src="searchUrl" alt="">
            <input type="text" v-model="keyword" :placeholder="i18n.t('login.labelPlaceholder4')" @input="searchCountry" @change="searchCountry">
          </div>
        </div>
        <div class="group-list login" v-for="(item, i) in countryList" :key="i">
          <div class="country-title" :id="item.id" v-if="item.id != 'common' && !keyword">{{item.title}}</div>
          <div class="country-title flex-center-start" v-if="item.id == 'common' && !keyword">
            <img :src="starUrl" alt="">
            {{$t('common.use')}}
          </div>
          <div class="list flex-center-start" :class="child.key == phonePre ? 'active' : ''" v-for="(child, index) in item.children" :key="index" @click.stop="chooseCountry(child)">
            <div class="img-box flex-center">
              <img :src="child.icon" alt="">
              <span>{{getCountryName(child.title)}}</span>
            </div>
            <div class="key">
              {{child.key}}
            </div>
          </div>
        </div>
        <div class="fast-link">
          <div class="link" v-for="(item, i) in linkList" :key="i" @click="toFastPage(item)">
            {{item.title}}
          </div>
        </div>
			</div>
    </Popup>
  </div>
</template>
<script>
  import { Button, Popup, Icon } from 'vant'
  import {
    login,
    phoneLogin,
    sendAuthCode,
    checkEmailCode,
    sendAuthSms,
    checkPhoneCode,
    sendSms,
    sendCode
  } from '@/api/login'
  import { setToken, setUser, setUserEmail, setUserId } from '@/utils/auth'
  import { getDefaultLanguage, getLanguageShortName } from '@/i18n/languages'
  export default {
    components: {
      Button,
      Popup,
      Icon
    },
    data() {
      return {
        step: 1,
        form: {
          username: '',
          phone: '',
          password: ''
        },
        keyword: '',
        phonePre: '+1',
        currentLangName: '',
        logoUrl: require('../../assets/imgs/logo6.png'),
        starUrl: require('../../assets/imgs/icon-star.png'),
        backUrl: require('../../assets/imgs/icon-back.png'),
        emailUrl: require('../../assets/imgs/icon-email2.png'),
        passwordUrl: require('../../assets/imgs/icon-password.png'),
        phoneUrl: require('../../assets/imgs/icon-phone2.png'),
        searchUrl: require('../../assets/imgs/icon-search.png'),
        eyeUrl: require('../../assets/imgs/icon-eye.png'),
        eyeUrl2: require('../../assets/imgs/icon-eye2.png'),
        showPassword: false,
        inputActive: false,
        tabIndex: 1,
        showPopup: false,
        countryList: [],
        linkList: [],
        isDisabled: false,
        sendTime: '',
      }
    },
    computed: {
      countryListBak() {
        return this.$store.state.countryList
      },
      btnShow() {
        if (this.step == 1) {
          if (this.tabIndex == 1) {
            return this.form.username && this.form.password
          } else {
            return this.form.phone && this.form.password
          }
        } else {
          return this.form.code
        }
      },
      timeCount() {
        return this.sendTime + 's'
      },
    },
    mounted() {
      this.countryList = [].concat(this.countryListBak)
      this.linkList = this.countryList.filter(v => {
        return v.id != 'common'
      })
      // 初始化当前语言显示
      this.initCurrentLang()
    },
    methods: {
      // 初始化当前语言显示
      initCurrentLang() {
        let locale = localStorage.getItem('locale')
        const defaultLanguage = getDefaultLanguage()
        const currentLang = locale ? locale : defaultLanguage
        this.currentLangName = getLanguageShortName(currentLang)
      },
      // 跳转到语言选择页面
      toLangPage() {
        this.$router.push({
          name: 'lang'
        })
      },
      changeTab(index) {
        this.tabIndex = index
      },
      back() {
        this.$router.push({
            name: 'index'
        })
      },
      toPath(path) {
        if (path) {
          this.$router.push({
            name: path
          })
        }
      },
      toRegister() {
        this.$router.push({
          name: 'register'
        })
      },
      changePassword() {
        this.showPassword = !this.showPassword
      },
      submit() {
        if (this.step == 1) {
          this.doLogin()
        } else {
          this.doLogin(true)
        }
      },
      doLogin(isLast) {
        if (this.tabIndex == 1) {
          let param = {
            Email: this.form.username,
              Password: this.form.password,
          }
          if (isLast) {
            param.Code = this.form.code
          }
          login(param).then(res => {
            if (res.code == 0) {
              this.$toast.success(this.i18n.t('login.success'))
              setToken(res.data.token)
              setUser(this.form.username)
              setUserEmail(this.form.username)
              setUserId(res.data.id)
              this.$router.push({
                name: 'index'
              })
            } else if (res.code == 1) {
              this.sendEmail()
            } else {
                this.$toast.fail(res.msg)
            }
          })
        } else {
          let param = {
            Phone: this.phonePre + this.form.phone,
            Password: this.form.password,
          }
          if (isLast) {
            param.Code = this.form.code
          }
          phoneLogin(param).then(res => {
            if (res.code == 0) {
              this.$toast.success(this.i18n.t('login.success'))
              setToken(res.data.token)
              setUser(this.phonePre + this.form.phone)
              setUserEmail('')
              setUserId(res.data.id)
              this.$router.push({
                name: 'index'
              })
            } else if (res.code == 1) {
              this.sendPhoneSms()
            }  else {
              this.$toast.fail(res.msg)
            }
          })
        }
      },
      cancel() {
        this.showPopup = false
      },
      changePre() {
        this.showPopup = true
      },
      chooseCountry(data) {
        this.phonePre = data.key
        this.showPopup = false
      },
      getCountryName(name) {
        if (!name) {
          return ''
        }
        let newName = ''
        newName = name.substring(0, name.indexOf('(') - 1)
        return newName
      },
      searchCountry() {
        if (this.keyword) {
          this.countryList = this.countryListBak.map(v => {
            let children = v.children.filter(val => {
              return val.title.toLowerCase().indexOf(this.keyword.toLowerCase()) > -1 && v.id != 'common'
            })
            if (children.length > 0) {
              return {
                children: children
              }
            } else {
              return {
                children: []
              }
            }
          })
        } else {
          this.countryList = [].concat(this.countryListBak)
        }
      },
      toFastPage(key) {
        let dom = document.getElementById(key.id)
        let parentDom = document.querySelector('.country-list')
        if (dom && parentDom) {
          let domTop = dom.offsetTop
          parentDom.scrollTo({
            top: domTop - 124
          })
        }
      },
      resend() {
        if (this.isDisabled) {
          return
        } else {
          this.sendEmail()
        }
      },
      countDown(time) {
        if (time > 0) {
          this.isDisabled = true
          time -= 1
          this.sendTime = time
          setTimeout(() => {
            this.countDown(time)
          }, 1000)
        } else {
          this.sendTime = ''
          this.isDisabled = false
        }
      },
      sendPhoneSms(){
        if (!this.form.phone) {
          this.$toast.fail(this.i18n.t('register.labelPlaceholder8'))
          return
        }
        let form = new FormData()
        form.append('Phone', this.phonePre + this.form.phone)
        form.append('Type', 5)
        sendSms(form).then(res => {
          if (res.code == 0) {
            this.step = 2
            this.countDown(60)
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      sendEmail() {
        if (!this.form.username) {
          this.$toast.fail(this.i18n.t('register.labelPlaceholder1'))
          return
        }
        let form = new FormData()
        form.append('Email', this.form.username)
        form.append('Type', 5)
        sendCode(form).then(res => {
          if (res.code == 0) {
            this.step = 2
            this.countDown(60)
          } else {
            this.$toast.fail(res.msg)
          }
        })
      },
      toSet() {
        if (!this.form.code ) {
          this.$toast.fail(this.i18n.t('register.labelPlaceholder2'))
          return
        }
        let form = new FormData()
        form.append('Code', this.form.code)
        form.append('Type', 5)
        if (this.tabIndex == 1) {
          form.append('Email', this.form.username)
          checkEmailCode(form).then(res => {
            if (res.code == 0) {
              this.doLogin()
            } else {
              this.$toast.fail(res.msg)
            }
          })
        } else {
          form.append('Phone', this.phonePre + this.form.phone)
          checkPhoneCode(form).then(res => {
            if (res.code == 0) {
              this.doLogin()
            } else {
              this.$toast.fail(res.msg)
            }
          })
        }
      }
    }
  }
</script>
